import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ChevronRight } from "lucide-react";
import { CITIES, COUNTIES, STATES } from "../../lib/locations";
import { AREAS_IMG } from "../../lib/site";

const Group = ({ title, items, testid }) => (
  <div data-testid={testid}>
    <h3 className="font-heading text-xl font-bold uppercase tracking-tight text-[#0E2A56] mb-3">
      {title}
    </h3>
    <div className="flex flex-wrap gap-2">
      {items.map((l) => (
        <Link
          key={l.slug}
          to={`/service-area/${l.slug}`}
          data-testid={`area-link-${l.slug}`}
          className="inline-flex items-center gap-1.5 bg-white border-2 border-[#0E2A56] px-3 py-2 font-heading font-semibold uppercase tracking-wide text-[#0E2A56] text-xs sm:text-sm hover:bg-[#0E2A56] hover:text-white transition-colors"
        >
          <MapPin className="h-3.5 w-3.5 text-[#C8102E] shrink-0" strokeWidth={3} />
          {l.label}
        </Link>
      ))}
    </div>
  </div>
);

export const ServiceAreas = () => {
  return (
    <section id="areas" data-testid="areas-section" className="relative py-20 md:py-28">
      <div className="absolute inset-0">
        <img src={AREAS_IMG} alt="Blue Ridge Mountains of North Georgia" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[#F6F5F0]/94" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="font-heading font-bold uppercase tracking-[0.2em] text-[#C8102E] text-sm">
          Proudly Local
        </p>
        <h2 className="mt-2 font-heading text-4xl sm:text-5xl font-extrabold uppercase tracking-tight text-[#0E2A56]">
          Service Areas We Cover
        </h2>
        <p className="mt-4 max-w-3xl text-lg text-slate-700 font-medium">
          Based in Blairsville, GA, we bring reliable handyman and restoration services to
          communities across North Georgia, western North Carolina and southeast Tennessee.
          Tap your city, county or state for local details.
        </p>

        <div className="mt-10 space-y-10">
          <Group title="Cities & Towns" items={CITIES} testid="areas-cities" />
          <Group title="Counties" items={COUNTIES} testid="areas-counties" />
          <Group title="States We Serve" items={STATES} testid="areas-states" />
        </div>
      </div>
    </section>
  );
};
